import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "manager-container"
};
const _hoisted_2 = {
  class: "schedule-container"
};
const _hoisted_3 = {
  class: "role-container"
};
const _hoisted_4 = {
  key: 0,
  class: "empty-data-tips"
};
const _hoisted_5 = {
  key: 1,
  class: "node-operate-bar"
};
const _hoisted_6 = {
  class: "role-container"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "nickname"
};
const _hoisted_9 = {
  class: "operate-item"
};
const _hoisted_10 = {
  class: "operate-item"
};
const _hoisted_11 = {
  class: "operate-item"
};
import { ref, computed, onMounted } from 'vue';
import { ElImage, ElInput, ElInputNumber } from 'element-plus';
import { inApostleType, isApostleType, isUserType, placeholderImage } from "@/tools/utils";
import 'element-plus/es/components/progress/style/css';
import store from "@/store"; // pre-declaration

export default {
  __name: 'StageScheduleManager',
  props: {
    data: {
      type: [Object, null],
      required: true
    },
    actor: {
      type: Array,
      required: true
    }
  },
  emits: ['submitUpdates'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const updates = ref({
      "current_node": {},
      "schedule": []
    });
    const nodeForm = ref({
      "offset": 0,
      "time": "",
      "event": "",
      "roles": []
    }); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const isEdit = computed(() => {
      return updates.value.schedule.some(item => item.offset === nodeForm.value.offset);
    });
    const maxOffset = computed(() => {
      if (updates.value.schedule.length === 0) return 3;
      return updates.value.schedule.reduce((maxOffset, item) => Math.max(item.offset + 1, maxOffset), 3);
    }); // functions

    const getRoleAvatar = roleId => {
      const buffer = props.actor.filter(role => role.id === roleId);
      if (buffer.length === 0) return placeholderImage;
      return buffer[0].avatar;
    };

    const clickRole = role => {
      if (!inApostleType(userType.value)) return;
      const roleId = role.id;
      const index = nodeForm.value.roles.indexOf(roleId);

      if (index !== -1) {
        nodeForm.value.roles.splice(index, 1);
      } else {
        nodeForm.value.roles.push(roleId);
      }
    };

    const copyNode = offset => {
      const index = updates.value.schedule.findIndex(node => node.offset === offset);

      if (index === -1) {
        nodeForm.value = {
          "offset": offset,
          "time": "",
          "event": "",
          "roles": []
        };
      } else {
        const nodeData = updates.value.schedule[index];

        if (nodeForm.value.offset === nodeData.offset) {
          nodeForm.value = {
            "offset": 0,
            "time": "",
            "event": "",
            "roles": []
          };
        } else {
          nodeForm.value = structuredClone(nodeData);
        }
      }
    };

    const selectedCurrentNode = () => {
      const index = updates.value.schedule.findIndex(node => node.offset === nodeForm.value.offset);

      if (index !== -1) {
        updates.value.current_node = updates.value.schedule[index];
      }

      emits('submitUpdates', updates.value);
    };

    const submitNode = () => {
      const index = updates.value.schedule.findIndex(node => node.offset === nodeForm.value.offset);

      if (index !== -1) {
        updates.value.schedule[index] = nodeForm.value;

        if (updates.value.current_node.offset === nodeForm.value.offset) {
          updates.value.current_node = nodeForm.value;
        }
      } else {
        updates.value.schedule.push(nodeForm.value);
      }

      updates.value.schedule.sort((a, b) => a.offset - b.offset);
      emits('submitUpdates', updates.value);
      nodeForm.value = {
        "offset": 0,
        "time": "",
        "event": "",
        "roles": []
      };
    };

    const removeNode = () => {
      const index = updates.value.schedule.findIndex(node => node.offset === nodeForm.value.offset);

      if (index !== -1) {
        updates.value.schedule.splice(index, 1);
      }

      updates.value.schedule.sort((a, b) => a.offset - b.offset);
      emits('submitUpdates', updates.value);
      nodeForm.value = {
        "offset": 0,
        "time": "",
        "event": "",
        "roles": []
      };
    };

    const getNodeTitle = offset => {
      const index = updates.value.schedule.findIndex(node => node.offset === offset);
      if (index === -1) return '';
      const nodeData = updates.value.schedule[index];
      if (isUserType(userType.value)) return nodeData.time;
      return `${nodeData.time}（偏移${nodeData.offset}）`;
    };

    const getNodeClass = offset => {
      if (!updates.value.current_node?.offset) return 'pass-node';
      const index = updates.value.schedule.findIndex(node => node.offset === offset);
      if (index === -1) return 'pass-node';
      const current = updates.value.current_node?.offset;

      if (current === offset) {
        return 'current-node';
      } else if (current > offset) {
        return 'pass-node';
      } else {
        return '';
      }
    };

    const getNodeData = (offset, key) => {
      const index = updates.value.schedule.findIndex(node => node.offset === offset);
      if (index === -1) return '';
      const nodeData = updates.value.schedule[index];
      return nodeData[key] ? nodeData[key] : '';
    }; // lifecycle


    onMounted(() => {
      if (props.data) updates.value = props.data;
    });
    return (_ctx, _cache) => {
      const _component_el_timeline_item = _resolveComponent("el-timeline-item");

      const _component_el_timeline = _resolveComponent("el-timeline");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({
          length: maxOffset.value
        }), (_, index) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            key: index,
            hollow: true,
            timestamp: getNodeTitle(index),
            class: _normalizeClass(["event-item", getNodeClass(index)]),
            placement: "top",
            onClick: $event => copyNode(index)
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(getNodeData(index, 'event')), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNodeData(index, 'roles'), (roleId, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "node-role"
              }, [_createVNode(_unref(ElImage), {
                src: getRoleAvatar(roleId),
                fit: "cover",
                draggable: "false"
              }, null, 8, ["src"])]);
            }), 128))])]),
            _: 2
          }, 1032, ["timestamp", "class", "onClick"]);
        }), 128))]),
        _: 1
      })]), _unref(isUserType)(userType.value) && !props.data ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 未检测到事件表 ")) : _createCommentVNode("", true), _unref(isApostleType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[8] || (_cache[8] = _createElementVNode("text", null, [_createElementVNode("b", null, "参与节点角色")], -1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actor, (role, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["role-card", nodeForm.value.roles.includes(role.id) ? 'isSelected' : '']),
          key: index,
          onClick: $event => clickRole(role)
        }, [_createVNode(_unref(ElImage), {
          src: role.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("text", _hoisted_8, _toDisplayString(role.nickname), 1)], 10, _hoisted_7);
      }), 128))]), _createElementVNode("div", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("text", null, "时间标签", -1)), _createVNode(_unref(ElInput), {
        modelValue: nodeForm.value.time,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => nodeForm.value.time = $event),
        maxlength: "32",
        placeholder: "节点时间",
        type: "text",
        clearable: "",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("text", null, "事件标签", -1)), _createVNode(_unref(ElInput), {
        modelValue: nodeForm.value.event,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => nodeForm.value.event = $event),
        maxlength: "128",
        placeholder: "节点事件",
        class: "event-input",
        type: "text",
        clearable: "",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("text", null, "节点偏移", -1)), _createVNode(_unref(ElInputNumber), {
        modelValue: nodeForm.value.offset,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => nodeForm.value.offset = $event),
        min: 0,
        max: 999,
        placeholder: "节点偏移"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: selectedCurrentNode
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 应用为当前节点 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: removeNode
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 移除节点 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        onClick: submitNode
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(isEdit.value ? '修改节点' : '创建节点'), 1)]),
        _: 1
      })])])) : _createCommentVNode("", true)]);
    };
  }

};